import { render } from "./ActionForm.vue?vue&type=template&id=2426e88a"
import script from "./ActionForm.vue?vue&type=script&lang=js"
export * from "./ActionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__